// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.loaderPetroprix {
  width: auto;
  margin: 0 auto;
}

div.loaderPetroprix.small {
  width: 100%;
  margin-left: 0%;
}

div.loaderPetroprix {
  margin-left: -20%;
}

div.loaderPetroprix img {
  position: fixed;
}

div.loaderPetroprix img.letter {
  height: 60px;
  margin-top: 21px;
  margin-left: 2px;
}

/* Animamos el circulo para que rote */
.circle {
  animation: rotate 2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
}

.letter {
  animation: shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97);
  animation-delay: 0.2s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes shake {
  20% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  25% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  30% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  35% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  45% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  50% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  55% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  60% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  65% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  70% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoaderPetroprix.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,mEAAmE;AACrE;;AAEA;EACE,wDAAwD;EACxD,qBAAqB;EACrB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["div.loaderPetroprix {\n  width: auto;\n  margin: 0 auto;\n}\n\ndiv.loaderPetroprix.small {\n  width: 100%;\n  margin-left: 0%;\n}\n\ndiv.loaderPetroprix {\n  margin-left: -20%;\n}\n\ndiv.loaderPetroprix img {\n  position: fixed;\n}\n\ndiv.loaderPetroprix img.letter {\n  height: 60px;\n  margin-top: 21px;\n  margin-left: 2px;\n}\n\n/* Animamos el circulo para que rote */\n.circle {\n  animation: rotate 2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;\n}\n\n.letter {\n  animation: shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97);\n  animation-delay: 0.2s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n}\n\n@keyframes shake {\n  20% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n\n  25% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n\n  30% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n\n  35% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n\n  45% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n\n  50% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n\n  55% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n\n  60% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n\n  65% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n\n  70% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(-360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
